import {useCallback} from 'react';

import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';
import {TrackingEvent} from '@/services';

export const useResetPasswordTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackResetPassword = useCallback(
    (eventName: TrackingEvent, err?: any) => {
      trackEvent(eventName, {
        project_tag: PROJECT_TAGS.PASSWORD,
        ...(err && {
          error: {
            code: err?.code || err?.name,
            message: err?.message,
          },
        }),
      });
    },
    [trackEvent],
  );

  return {
    trackResetPassword,
  };
};
